<form *ngIf="form" class="policy-form" [formGroup]="form" (ngSubmit)="save()">
  <div class="policy-form__header">
    <div>
      <h3 class="m-0 text-strong">Editar póliza</h3>
      <small>{{ data?.transportCompany?.name }} · NIT {{ data?.transportCompany?.companyId }}</small>
    </div>
    <button mat-icon-button type="button" matTooltip="Cerrar" (click)="dialogRef.close()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="policy-form__body">
    <p class="policy-form__title">Póliza</p>
    <mat-radio-group class="policy-form__options" formControlName="policyByCompany">
      <mat-radio-button [value]="false">Póliza única para todos los clientes.</mat-radio-button>
      <mat-radio-button [value]="true">Póliza individual para cada cliente.</mat-radio-button>
    </mat-radio-group>

    <p class="policy-form__title">Datos de la póliza</p>
    <div class="alert alert-warning" *ngIf="policyExpired" role="alert">
      <i class="fas fa-exclamation-triangle"></i>
      La póliza se encuentra vencida. Selecciona una nueva fecha de expiración para actualizarla.
    </div>

    <div class="row" formGroupName="insuranceInformation">
      <div class="col-md-6">
        <mat-form-field appearance="standard">
          <mat-label>NIT de la entidad emisora<span class="asterisk">*</span></mat-label>
          <input matInput type="text" onlyNumbersInt formControlName="companyId">
          <mat-error *ngIf="form.get('insuranceInformation.companyId').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
          <mat-error *ngIf="form.get('insuranceInformation.companyId').errors?.maxlength">
            {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'nit de la entidad emisora', 10) }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="standard">
          <mat-label>Nombre de la entidad emisora<span class="asterisk">*</span></mat-label>
          <input matInput type="text" formControlName="companyName">
          <mat-error *ngIf="form.get('insuranceInformation.companyName').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="standard">
          <mat-label>N° de póliza<span class="asterisk">*</span></mat-label>
          <input matInput type="text" onlyNumbersInt formControlName="policyNumber">
          <mat-error *ngIf="form.get('insuranceInformation.policyNumber').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="standard">
          <mat-label>Fecha de expiración<span class="asterisk">*</span></mat-label>
          <input matInput [matDatepicker]="datePicker" formControlName="expirationDate"
            [matDatepickerFilter]="fromNowFilter" (click)="datePicker.open()" readonly>
          <mat-error *ngIf="form.get('insuranceInformation.expirationDate').errors?.required">
            {{ utils.giveMessageError('MANDATORY_FIELD') }}
          </mat-error>
          <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="policy-form__actions">
    <button mat-button type="button" (click)="dialogRef.close()" [disabled]="saving">Cancelar</button>
    <button mat-flat-button color="primary" class="bg-color-primary" type="submit" [disabled]="saving">
      {{ saving ? 'Guardando...' : 'Guardar' }}
    </button>
  </div>
</form>
